import script from "./NhapXuatTonKho.vue?vue&type=script&lang=ts&setup=true"
export * from "./NhapXuatTonKho.vue?vue&type=script&lang=ts&setup=true"

import "./NhapXuatTonKho.vue?vue&type=style&index=0&id=c4a894e4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c4a894e4"]])

export default __exports__